import { inject, Injectable } from '@angular/core';

import {
  EventService,
  ProductSearchPage,
  RoutingService,
  SearchboxService,
  TranslationService,
  WindowRef
} from '@spartacus/core';
import { SearchBoxComponentService, SearchBoxConfig, SearchResults } from '@spartacus/storefront';
import { combineLatest, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';

import { DpRelatedPartProductNormalizer } from '@app/core/converters/related-part-product.normalizer';

const HAS_SEARCH_RESULT_CLASS = 'has-searchbox-results';

@Injectable()
export class DpSearchBoxComponentService extends SearchBoxComponentService {
  readonly #relatedPartsNormalizer = inject(DpRelatedPartProductNormalizer);

  constructor(
    public searchService: SearchboxService,
    protected routingService: RoutingService,
    protected translationService: TranslationService,
    protected winRef: WindowRef,
    protected eventService: EventService
  ) {
    super(searchService, routingService, translationService, winRef, eventService);
  }

  getResults(config: SearchBoxConfig): Observable<SearchResults> {
    return combineLatest([
      this.getProductResults(config),
      this.getProductSuggestions(config),
      this.getSearchMessage(config)
    ])
      .pipe(
        map(([productResults, suggestions, message]) => ({
          products: this.#relatedPartsNormalizer.convert(productResults.relatedParts),
          suggestions,
          message
        }))
      )
      .pipe(tap((results) => this.toggleBodyClass(HAS_SEARCH_RESULT_CLASS, this.hasResults(results))));
  }

  protected getProductResults(config: SearchBoxConfig): Observable<ProductSearchPage> {
    if (config.displayProducts) {
      return this.searchService.getResults();
    }

    return of({} as ProductSearchPage);
  }
}
